module.exports = __webpack_public_path__ + "static/media/JunctionX Singapore logo_white_twoline.830444bb.png";